<template>
  <div @click="show_alert = false">
    <!--<b-button size="sm" @click="toggle_alert()">
      SHOW
    </b-button>-->
    <b-alert
      v-model="show_alert"
      class="position-fixed fixed-bottom m-2 rounded-0 toast-alert"
      :variant="variant"
      dismissible
    >
      <span v-html="text"></span>
    </b-alert>
  </div>
</template>

<script>
const DEFAULT_TIMER = 10000;

export default {
  data() {
    return {
      timeout: undefined, 
      show_alert: false,
      text: '',
      timer: DEFAULT_TIMER,
      variant: 'warning',
    }
  },
  beforeDestroy() { 
    clearTimeout(this.timeout);
  },
  methods: {
    reset_defaults() {
      this.show_alert = false;
      this.text = '';
      this.timer = DEFAULT_TIMER; 
      this.variant = 'warning'
    },
    handle_notification(data) {
      this.reset_defaults();
      if (data.text) this.text = data.text
      if (data.timer > 0) this.timer = data.timer 
      if (data.variant) this.variant = data.variant
      this.toggle_alert()
    },
    toggle_alert() {
      clearTimeout(this.timeout);
      this.show_alert = true;
      this.timeout = setTimeout(() => {
        this.show_alert = false; 
      }, this.timer);
    }
  },
}
</script>

<style lang="scss">
.toast-alert {
  cursor: pointer;
  display: inline-block;
  left: auto !important;
  width: auto !important;
  right: 0;
  max-width: 320px;
}
</style>